import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { monthlyTrainingPlanSummaryApi } from "../../../../../services/human-organization/monthly-training-plan-summary.service";

export const useMTPSRequest = () => {
  const { id } = useParams<{ id: string }>();
  return useQuery({
    queryKey: ["MTPS-requests", id],
    queryFn: () => monthlyTrainingPlanSummaryApi.getRequest(id),
    select: monthlyTrainingPlanSummaryApi.toResponse,
  });
};
